import React from "react";
import { Redirect } from "react-router-dom";
// User profile
import UserProfile from "../pages/Authentication/UserProfile";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import MyTable from "../pages/Coupons";
// import CouponFormComponent from "../pages/Coupons/CouponFormComponent";
// import CouponForm from "pages/CouponFrom";
import ForgetPwd from "../pages/Authentication/ForgetPassword";
import TagGeneration from "../pages/Taggeneration/index";

// Dashboard
import Dashboard from "../pages/Dashboard/index";
import ContactsList from "../pages/Users/index";
import TagsList from "../pages/Tags/index";
import Macpairing from "pages/Macpairing/Macpairing";
import TagUpdate from "pages/TagUpdate/TagUpdate";
import ProductCategoryRequest from "pages/ProductCategoryRequest/ProductCategoryRequest";
import Managereturn from "pages/managereturn/Managereturn";
import Returnproducts from "pages/returnproducts/Returnproducts";
import Insurancedetails from "pages/insurancedetails/Insurancedetails";
import CreateAdmins from "pages/Admins";
import Dispatch from "pages/Dispatchmodule/Dispatch";
import Visualization from "../pages/Visualization/index.js";
import Billing from "../pages/Billing/index.js";
import Companywise from "pages/companywise";
import IssueETag from "../partnerportal/pages/IssueETag";
import IssueBagProtectionPolicy from "../partnerportal/pages/IssueBagProtectionPolicy";
import IssueQrBagTagPlan from "../partnerportal/pages/IssueQrBagTagPlan";
import CompanyManagement from "pages/Company";
import BranchUser from "pages/Company/BranchUser";
import AdminVerification from "pages/Company/AdminVerification";
import PartnerCompanyDetails from "../pages/Company/PartnerCompanyDetails";
import CompanyManagementDetails from "pages/Company/components/CompanyManagementDetails";
import CompanyWallet from "pages/Company/components/CompanyWallet";

const authProtectedRoutes = [
  { path: "/partner/dashboard", component: Dashboard },
  { path: "/partner/issue-e-tag", component: IssueETag },
  {
    path: "/partner/issue-bag-protection-policy",
    component: IssueBagProtectionPolicy,
  },
  {
    path: "/partner/issue-qr-bag-tag-plan",
    component: IssueQrBagTagPlan,
  },
  { path: "/companywise-activation", component: Companywise },
  { path: "/macpairing", component: Macpairing },
  { path: "/branchuser", component: BranchUser },
  { path: "/returnproducts", component: Returnproducts },
  { path: "/managereturn", component: Managereturn },
  { path: "/dashboard", component: Dashboard },
  { path: "/lostandfound", component: Insurancedetails },

  //profile
  { path: "/profile", component: UserProfile },

  //profile
  { path: "/user-list", component: ContactsList },

  //tags
  { path: "/tags-list", component: TagsList },
  { path: "/tagupdate", component: TagUpdate },
  { path: "/productcategoryrequest", component: ProductCategoryRequest },
  { path: "/coupon-list", component: MyTable },

  { path: "/taggeneration-list", component: TagGeneration },

  // admins
  { path: "/admin-list", component: CreateAdmins },
  { path: "/dispatch", component: Dispatch },

  //Visualization
  { path: "/visualization", component: Visualization },
  //Visualization
  { path: "/billing-management", component: Billing },
  { path: "/companymanagement", component: CompanyManagement },
  { path: "/companydetails", component: PartnerCompanyDetails },
  {
    path: "/companymanagement/:company_uid/wallet",
    component: CompanyWallet,
  },
  {
    path: "/companymanagement/:company_uid",
    component: CompanyManagementDetails,
  },
  // { path: "/coupon-form", component: CouponForm },
  // { path: "/coupon-form", component: CouponFormComponent },
  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  { path: "/", exact: true, component: () => <Redirect to="/dashboard" /> },
];

const publicRoutes = [
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/register", component: Register },
  { path: "/adminverify/:uid", component: AdminVerification },
];

export { authProtectedRoutes, publicRoutes };
